export type OriginalHandling =
  | "keep_received"
  | "keep_and_receive_more"
  | "return_all";

export type CancellationReceivedHandling = "keep_received" | "return_received";
export type ComposerMode = "replacement" | "cancellation";

export function getAllowedComposerMode(
  mode: ComposerMode,
  allowReplacement: boolean,
  allowCancellation: boolean,
) {
  if (mode === "replacement" && !allowReplacement && allowCancellation)
    return "cancellation";
  if (mode === "cancellation" && !allowCancellation && allowReplacement)
    return "replacement";
  return mode;
}

export type ReplacementCommercialSnapshot = {
  productId: string;
  supplierId: string;
  unitType: string;
  quantity: number;
  realPrice: number;
  finalPrice: number;
};

function formatQuantity(value: number) {
  return new Intl.NumberFormat("pt-BR", {
    maximumFractionDigits: 3,
  }).format(value);
}

export function formatReplacementResult({
  handling,
  received,
  additional,
  replacement,
}: {
  handling: OriginalHandling;
  received: number;
  additional: number;
  replacement: number;
}) {
  const receivedResult =
    handling === "return_all"
      ? `${formatQuantity(received)} devolvida${received === 1 ? "" : "s"}`
      : `${formatQuantity(received)} recebida${received === 1 ? "" : "s"}`;
  const additionalResult =
    handling === "keep_and_receive_more"
      ? ` + ${formatQuantity(additional)} adiciona${additional === 1 ? "l" : "is"}`
      : "";
  return `${receivedResult}${additionalResult} + ${formatQuantity(replacement)} substituída${replacement === 1 ? "" : "s"}`;
}

export function isReplacementNoop({
  original,
  replacement,
  handling,
}: {
  original: ReplacementCommercialSnapshot;
  replacement: ReplacementCommercialSnapshot;
  handling: OriginalHandling;
}) {
  return (
    handling === "keep_received" &&
    original.productId === replacement.productId &&
    original.supplierId === replacement.supplierId &&
    original.unitType === replacement.unitType &&
    original.quantity === replacement.quantity &&
    original.realPrice === replacement.realPrice &&
    original.finalPrice === replacement.finalPrice
  );
}
